export const zh = {
  "header": {
    "brand": "CikaStudio",
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "nav": {
    "tools": "工具",
    "games": "游戏",
    "about": "关于"
  },
  "actions": {
    "copy": "复制",
    "download": "下载",
    "clear": "清空",
    "copied": "已复制!",
    "copyAll": "复制全部",
    "downloadTxt": "下载 TXT",
    "generate": "生成",
    "regenerate": "重新生成",
    "format": "格式化",
    "minify": "压缩",
    "validate": "验证",
    "convert": "转换"
  },
  "footer": {
    "privacy": "隐私",
    "terms": "条款",
    "email": "联系我们",
    "moreTools": "更多工具",
    "copyright": "© {year} CikaStudio. 保留所有权利。"
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "浅色",
    "dark": "深色"
  },
  "common": {
    "clientSide": "100% 客户端处理",
    "noUpload": "不上传数据",
    "noAccount": "无需账号",
    "loading": "加载中...",
    "error": "错误",
    "success": "成功"
  },
  "unitConverter": {
    "title": "单位换算器",
    "subtitle": "支持 10 余种单位类别之间的换算。",
    "privacy": "100% 客户端处理",
    "searchPlaceholder": "搜索类别或单位...",
    "from": "从",
    "to": "到",
    "quickConversions": "快速换算",
    "length": "长度",
    "weight": "重量",
    "temperature": "温度",
    "area": "面积",
    "volume": "体积",
    "speed": "速度",
    "time": "时间",
    "data": "数据",
    "energy": "能量",
    "m": "米",
    "km": "千米",
    "cm": "厘米",
    "mm": "毫米",
    "mi": "英里",
    "yd": "码",
    "ft": "英尺",
    "in": "英寸",
    "kg": "千克",
    "g": "克",
    "mg": "毫克",
    "t": "公吨",
    "lb": "磅",
    "oz": "盎司",
    "c": "摄氏度",
    "f": "华氏度",
    "k": "开尔文",
    "m2": "平方米",
    "km2": "平方千米",
    "ha": "公顷",
    "ac": "英亩",
    "ft2": "平方英尺",
    "l": "升",
    "ml": "毫升",
    "m3": "立方米",
    "gal": "加仑（美制）",
    "qt": "夸脱（美制）",
    "cup": "杯（美制）",
    "m/s": "米/秒",
    "km/h": "千米/小时",
    "mph": "英里/小时",
    "kn": "节",
    "s": "秒",
    "min": "分钟",
    "h": "小时",
    "d": "天",
    "wk": "周",
    "mo": "月（平均）",
    "y": "年",
    "b": "字节",
    "kb": "千字节",
    "mb": "兆字节",
    "gb": "吉字节",
    "tb": "太字节",
    "bit": "比特",
    "j": "焦耳",
    "kj": "千焦",
    "cal": "卡路里",
    "kcal": "千卡",
    "wh": "瓦时",
    "kwh": "千瓦时"
  },
  "security": {
    "note": "🔒 所有处理均在您的浏览器本地完成，数据不会上传至任何服务器。"
  },
  "content": {
    "privacy": {
      "title": "隐私与安全",
      "description": "🔒 所有单位转换均在您的浏览器本地完成。任何测量数据都不会被上传到任何服务器。"
    },
    "guide": {
      "title": "如何使用单位转换器",
      "description": "使用准确的实时结果，即时在 10 多个单位类别之间进行转换。",
      "steps": [
        {
          "title": "选择类别",
          "description": "从长度、重量、温度、体积、面积、速度、时间、数据、压力、能量等类别中进行选择。"
        },
        {
          "title": "输入数值",
          "description": "输入要转换的数值，并选择源单位和目标单位。输入时结果会自动更新。"
        },
        {
          "title": "复制或收藏",
          "description": "将转换后的值复制到剪贴板，或收藏常用转换以便日后快速访问。"
        }
      ]
    },
    "features": {
      "title": "核心功能",
      "items": [
        "10 多个转换类别，包含 100 多个单位",
        "输入时实时显示结果",
        "基于标准 SI 定义的准确公式",
        "一键反向转换",
        "简洁、响应式界面，适配移动端和桌面端",
        "100% 客户端处理 — 零数据上传"
      ]
    },
    "faq": {
      "title": "常见问题",
      "items": [
        {
          "question": "我的数据会被发送到服务器吗？",
          "answer": "不会。所有计算均在您的浏览器中使用 JavaScript 本地完成。任何测量数据都不会离开您的设备。"
        },
        {
          "question": "转换结果有多准确？",
          "answer": "所有转换均使用标准 SI 定义和国际认可的转换系数。结果至少精确到小数点后 6 位，适用于科学和工程用途。"
        },
        {
          "question": "可以在不相关的类别之间转换吗？",
          "answer": "您可以在任何类别内进行转换（例如米到英尺），但不能跨类别转换（例如重量到温度）。请根据您的需求选择适当的类别。"
        }
      ]
    },
    "related": {
      "title": "相关工具",
      "tools": [
        {
          "name": "百分比计算器",
          "url": "/utility/percentage-calculator",
          "description": "在浏览器中进行即时百分比计算。"
        },
        {
          "name": "时间戳转换器",
          "url": "/utility/timestamp-converter",
          "description": "在 Unix 时间戳和人类可读日期之间进行转换。"
        },
        {
          "name": "Base64 转换器",
          "url": "/converter/base64",
          "description": "快速安全地编码和解码 Base64 字符串。"
        }
      ]
    }
  }
};
